import { DEPARTEMENTS } from "../data/departements";

const CODES_DROM = ["971", "972", "973", "974", "976"];

/**
 * Déduit le département (code + nom) à partir d'un code postal français.
 * Cas particulier de la Corse : la distinction 2A / 2B ne se fait pas
 * uniquement sur les deux premiers chiffres ("20" pour les deux), on
 * approxime ici par la valeur numérique complète du code postal
 * (2A : 20000-20199, 2B : 20200-20620). Cette approximation peut être
 * fausse à la marge pour quelques communes ; à affiner si besoin d'une
 * précision parfaite.
 *
 * @param {string} codePostal - 5 chiffres
 * @returns {{code: string, nom: string} | null}
 */
export function departementFromCodePostal(codePostal) {
  if (!/^\d{5}$/.test(codePostal)) return null;

  const prefixe3 = codePostal.slice(0, 3);
  if (CODES_DROM.includes(prefixe3)) {
    return DEPARTEMENTS.find((d) => d.code === prefixe3) || null;
  }

  const prefixe2 = codePostal.slice(0, 2);
  if (prefixe2 === "20") {
    const valeur = parseInt(codePostal, 10);
    const codeCorse = valeur <= 20199 ? "2A" : "2B";
    return DEPARTEMENTS.find((d) => d.code === codeCorse) || null;
  }

  return DEPARTEMENTS.find((d) => d.code === prefixe2) || null;
}
